var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Input } from './input.js';
import { Select } from './select.js';
import { Copy } from './copy.js';
import { Errors, Err } from './form-elements/shared.js';
import styled from 'styled-components';
import { inputPattern, noop } from '@navinc/utils';
export const DatePickerWrapper = styled.div.withConfig({ displayName: "brc-sc-DatePickerWrapper", componentId: "brc-sc-102rw0x" }) `
  div > ${Copy} {
    text-align: left;
  }
`;
const StyledCopy = styled(Copy).withConfig({ displayName: "brc-sc-StyledCopy", componentId: "brc-sc-tvzfmn" }) `
  margin-bottom: 8px;
`;
export const DatePickerInputWrapper = styled.div.withConfig({ displayName: "brc-sc-DatePickerInputWrapper", componentId: "brc-sc-16veeuh" }) `
  display: grid;
  grid-gap: 12px;
  grid-template-columns: ${({ fieldsToShow = [] }) => {
    if (fieldsToShow.length === 3) {
        return '5fr 2fr 2.5fr';
    }
    else if (fieldsToShow.length === 2) {
        return '1fr 1fr';
    }
    else {
        return '1fr';
    }
}};

  ${Errors} {
    display: none;
  }
`;
const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
export function isDateValid(dateIn) {
    if (!dateIn || !dateIn.year || !dateIn.month || !dateIn.day)
        return false;
    const { year, month, day } = dateIn;
    if (year.toString().length !== 4) {
        return false;
    }
    const yearNumber = Number(year);
    const monthNumber = Number(month);
    const dayNumber = Number(day);
    const date = new Date(yearNumber, monthNumber - 1, dayNumber);
    return date.getFullYear() === yearNumber && date.getMonth() + 1 === monthNumber && date.getDate() === dayNumber;
}
const _DatePicker = (_a) => {
    var _b;
    var { errors = [], fieldsToShow = ['day', 'month', 'year'], hasSpaceForErrors, isInvalid, label, name, onBlur, onChange = noop, value = {} } = _a, rest = __rest(_a, ["errors", "fieldsToShow", "hasSpaceForErrors", "isInvalid", "label", "name", "onBlur", "onChange", "value"]);
    const onChangeWrapper = (key, val) => {
        onChange({
            target: {
                value: Object.assign(Object.assign({}, value), { [key]: val }),
            },
        });
    };
    const handleMonthChange = (event) => {
        const monthNumber = months.indexOf(event.target.value) + 1;
        const val = monthNumber < 10 ? `0${monthNumber}` : `${monthNumber}`;
        onChangeWrapper('month', val);
    };
    const handleDayChange = (event) => {
        onChangeWrapper('day', inputPattern(event.target, '99'));
    };
    const handleYearChange = (event) => {
        onChangeWrapper('year', inputPattern(event.target, '9999'));
    };
    const isInvalidOrHasErrors = isInvalid || !!errors.length;
    return (_jsxs(DatePickerWrapper, Object.assign({}, rest, { children: [label && (_jsx("div", { children: _jsx(StyledCopy, { light: true, size: "sm", children: label }) })), _jsxs(DatePickerInputWrapper, { fieldsToShow: fieldsToShow, children: [fieldsToShow.includes('month') && (_jsx(Select, { "data-testid": "date_picker:month", isInvalid: isInvalidOrHasErrors, label: "Month", name: name, options: months, onBlur: onBlur, onChange: handleMonthChange, value: (_b = months[parseInt(value.month, 10) - 1]) !== null && _b !== void 0 ? _b : 0 })), fieldsToShow.includes('day') && (_jsx(Input, { "data-testid": "date_picker:day", isInvalid: isInvalidOrHasErrors, label: "Day", name: "day", onBlur: onBlur, onChange: handleDayChange, 
                        // chrome 73 onWheel events became passive
                        onWheel: (e) => {
                            e.preventDefault();
                            e.target.blur();
                        }, type: "number", value: value.day || '' })), fieldsToShow.includes('year') && (_jsx(Input, { "data-testid": "date_picker:year", isInvalid: isInvalidOrHasErrors, label: "Year", name: "year", onBlur: onBlur, onChange: handleYearChange, 
                        // chrome 73 onWheel events became passive
                        onWheel: (e) => {
                            e.preventDefault();
                            e.target.blur();
                        }, type: "number", value: value.year || '' }))] }), _jsx(Errors, { hasSpaceForErrors: hasSpaceForErrors, "data-testid": "date_picker:errors", children: !!errors.length && errors.map((err, i) => _jsx(Err, { children: err }, `err-${i}`)) })] })));
};
export const DatePicker = styled(_DatePicker).withConfig({ displayName: "brc-sc-DatePicker", componentId: "brc-sc-9xv87p" }) ``;
//# sourceMappingURL=date-picker.js.map